import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/shop/src/components/sections/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/shop/src/components/sections/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/shop/src/components/sections/PrivacyPolicy.tsx");
